import classnames from "classnames";
import React from "react";

export function BettingTypeDescription(props: {
	name?: string;
	description: string;
	shouldDisplay: boolean;
	className?: string;
}) {
	if (!props.shouldDisplay) {
		return null;
	}

	return (
		<div
			className={classnames(
				props.className
					? props.className
					: "match__block__info u-padd--reset"
			)}
		>
			<div className="message message--sml message--info u-type--xsml">
				{props.description}
			</div>
		</div>
	);
}
